import { useTranslation } from 'react-i18next';
import { cn } from '@resource-kit/ui';
import { PHONE_STEPS, STEP_LABEL, type StepState } from './phoneModel';

// `on` fills a fixed third: the canvas's `.ac.on` is a CSS constant, not a ratio.
const SEGMENT_CLASS = {
  done: 'bg-success',
  on: 'bg-[linear-gradient(90deg,var(--primary)_33%,var(--border)_33%)]',
  todo: 'bg-border',
} as const satisfies Record<StepState, string>;

/** The six-step bar over both phone views (#2487 B1/B2). */
export function PhoneStageBar({ steps }: { steps: readonly StepState[] }) {
  const { t } = useTranslation();
  return (
    <div data-testid="phone-stage-bar" className="shrink-0">
      <div className="grid grid-cols-6 gap-1 px-4">
        {PHONE_STEPS.map((step, i) => {
          const state = steps[i] ?? 'todo';
          return (
            <span
              key={step}
              data-state={state}
              className={cn('h-1 rounded-micro', SEGMENT_CLASS[state])}
            />
          );
        })}
      </div>
      <div className="grid grid-cols-6 gap-1 px-4 pt-1.5 text-[11.5px] text-muted-foreground">
        {PHONE_STEPS.map((step, i) => (
          <span key={step} className={cn(steps[i] === 'on' && 'font-semibold text-foreground')}>
            {t(STEP_LABEL[step])}
          </span>
        ))}
      </div>
    </div>
  );
}
